import { PluginKey } from 'prosemirror-state';

export const trackedPluginKey = new PluginKey('tracked-plugin');
export const topMenuPluginKey = new PluginKey('top-menu-plugin');
export const promptMenuPluginKey = new PluginKey('prompt-menu-plugin');
export const uiStatePluginKey = new PluginKey('ui-state-plugin');
export const annotationPluginKey = new PluginKey('annotation-plugin');



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/keys.js